import { Component, OnInit , ViewChild, ElementRef} from '@angular/core';
import {FormBuilder,Validators,FormGroup} from '@angular/forms';
import { ActivatedRoute, Router} from '@angular/router';
// For social site login
import {AuthService, GoogleLoginProvider} from 'angularx-social-login';
import {HttpRequestService} from './../../_services/http-request.service';
import { EncrDecrService } from './../../_services/encr-decr.service';
import { CommonService } from './../../_services/common.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { async } from 'q';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
	@ViewChild('userTypecontent', {static: false})userTypecontent: ElementRef;
	public loginForm: FormGroup;
	public signUpForm: FormGroup;
	public socialData: FormGroup;
	public redirect_intended = "";
	constructor(
		private fb: FormBuilder,
		private socialAuthService: AuthService,
		private httpServices:HttpRequestService,
		public router: Router,
		private EncrDecr: EncrDecrService,
		private toastr: ToastrService,
		private commonService: CommonService,
		public translate: TranslateService,
		private modalService: NgbModal,
		private route:ActivatedRoute
	) {
		this.commonService.activelang.subscribe((lang) => {
			// this language will be used as a fallback when a translation isn't found in the current language
			translate.setDefaultLang(lang);
	  
			// the lang to use, if the lang isn't available, it will use the current loader to get them
			translate.use(lang);
		  });
	}

	ngOnInit() {
		this.route.queryParams.subscribe(params => {
			if (params.redirect_intended) {
				this.redirect_intended = params.redirect_intended;
			}
        });
		if(localStorage.getItem('_user')){
			this.router.navigate(['profile']);
		}
		this.loginForm = this.fb.group({
			email: ['', [Validators.required]],
			password: ['', ],
			is_social:[0]
		});
		this.signUpForm = this.fb.group({
			'user_type':[''],
			'email':[''],
			'first_name':[''],
			'last_name':[''],
			'lang':[localStorage.getItem('_lang')]
		});
	}
	async login(){
		if (this.loginForm.valid) {
			const form_data = this.loginForm.value;
			this.httpServices.setModule('action').post('login',form_data).subscribe(async (response) => {
			
				if (response.status=='success') {
					let userInfo = this.EncrDecr.set(JSON.stringify(response.data.user));
					localStorage.setItem('_user',userInfo);
					if(localStorage.getItem('_cartData')){
						// let cartData=JSON.parse(this.EncrDecr.get(localStorage.getItem('_cartData')));
						// cartData.map((el)=> el.user_id=response.data.user.id);
						// //console.log(cartData,"cartData");
						// let sendData:any={};
						// sendData.items=cartData;
						// this.httpServices.setModule('action').post('insert_cart',sendData).subscribe((res)=>{
						// 	if (res.status=='success') {
						// 		localStorage.removeItem('_cartData');
						// 	} else {
						// 		this.toastr.error( response.data,'Error:');
						// 	}
						//   });
						let cartData=JSON.parse(this.EncrDecr.get(localStorage.getItem('_cartData')));
						cartData.map((el)=> el.user_id=response.data.user.id);
						//console.log(cartData);
						cartData.forEach(async (element:any) => {
							this.httpServices.setModule('action').post('find_cart_item',element).subscribe((res)=>{
								if (res.status=='success') {
									// console.log(res);
									if(!res.data){
										// console.log("insert")
										let sendData:any={};
										sendData.items=[];
										sendData.items.push(element)
										// console.log(sendData)
										this.httpServices.setModule('action').post('insert_cart',sendData).subscribe((res)=>{
												if (res.status=='success') {
													//localStorage.removeItem('_cartData');
												} else {
													this.toastr.error( response.data,'Error:');
												}
										})
									} else {
										// console.log("update")
										this.httpServices.setModule('action').post('cart_update', {
											"item_count": element.item_count,
											"id": res.data.id
										  }).subscribe((res)=>{
											if (res.status=='success') {
												//localStorage.removeItem('_cartData');
											} else {
												this.toastr.error( response.data,'Error:');
											}
										})
									}

								}else {
									this.toastr.error( response.data,'Error:');
								}
							});
							// let cartData= JSON.parse(this.EncrDecr.get(localStorage.getItem('_cartData')));
							// // if(cartData){
							// // 	this.commonService.setCartItmsCount(cartData.length);
							// // }
      						
						});
					}
					//remove cart data from local storage
					localStorage.removeItem('_cartData');
					//update login to true
					this.commonService.setIsLogin(true);

					setTimeout(() => {
						//update count in cart icon
						this.httpServices.setModule('action').post('cart_details', {
							user_id: response.data.user.id
						}).subscribe((response) => {
							if (response.status == 'success') {
							let itemTotalQty = response.data.length;
							this.commonService.setCartItmsCount(itemTotalQty);
							} 
						})
						/************/
					},1500)


					//if there is intended path in URL then redict to the intended path
					if (this.redirect_intended &&
						this.redirect_intended != "" &&
						['/order/preview', '/order/billing'].includes(this.redirect_intended)) {
						this.router.navigateByUrl(this.redirect_intended);
					} else {
						this.router.navigate(['profile']);
					}
					
					
				}
				if (response.status=='error') {
					if(response.code == 'HC-L-0002'){
						// console.log('social attempt first');
						this.modalService.open(this.userTypecontent, { size: 'xl', backdrop: 'static', centered: true }).result.then((result) => {

						}, (reason) => {
					
						});
					}
					else{
						this.toastr.error( response.data,'Login');
					}
					
				}
			}, (error) => {
				//console.log(error);
			});
		}
	}
  //for social login
	public socialSignIn(socialPlatform: string) {
		let socialPlatformProvider;
	   if (socialPlatform === "google") {
			socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
		}
    socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
		this.socialAuthService.signIn(socialPlatformProvider).then(
			async (userData) => {
				// console.log(userData,"userData");
				
				await this.loginForm.patchValue({
					email:userData.email,
					is_social:1
				});
				await this.signUpForm.patchValue({
					email:userData.email,
					first_name:userData.firstName,
					last_name:userData.lastName
				});

				await this.login();
			}
		);
	}

	addUserType(type) {	
		this.signUpForm.patchValue({
			user_type:type,
		});
		this.modalService.dismissAll();
		//console.log(this.signUpForm.value);
		this.submitSignUpForm();
	}

	submitSignUpForm() {
	   
		if (this.signUpForm.valid) {
		  this.httpServices.setModule('action').post('social_signup_action',this.signUpForm.value).subscribe((response) => {
	
			if (response.status=='success') {
				let userInfo = this.EncrDecr.set(JSON.stringify(response.data));
				localStorage.setItem('_user',userInfo);
				this.router.navigate(['profile']);
				//update login to true
				this.commonService.setIsLogin(true);

				if(localStorage.getItem('_cartData')){

					let cartData=JSON.parse(this.EncrDecr.get(localStorage.getItem('_cartData')));
					cartData.map((el)=> el.user_id=response.data.id);
					//console.log(cartData);
					cartData.forEach(async (element:any) => {
						this.httpServices.setModule('action').post('find_cart_item',element).subscribe((res)=>{
							if (res.status=='success') {
								// console.log(res);
								if(!res.data){
									// console.log("insert")
									let sendData:any={};
									sendData.items=[];
									sendData.items.push(element)
									// console.log(sendData)
									this.httpServices.setModule('action').post('insert_cart',sendData).subscribe((res)=>{
											if (res.status=='success') {
												//localStorage.removeItem('_cartData');
											} else {
												this.toastr.error( response.data,'Error:');
											}
									})
								} else {
									// console.log("update")
									this.httpServices.setModule('action').post('cart_update', {
										"item_count": element.item_count,
										"id": res.data.id
										}).subscribe((res)=>{
										if (res.status=='success') {
											//localStorage.removeItem('_cartData');
										} else {
											this.toastr.error( response.data,'Error:');
										}
									})
								}

							}else {
								this.toastr.error( response.data,'Error:');
							}
						});

						
					});
				}
				//remove cart data from local storage
				localStorage.removeItem('_cartData');
				setTimeout(() => {
					//update count in cart icon
					this.httpServices.setModule('action').post('cart_details', {
						user_id: response.data.id
					}).subscribe((response) => {
						if (response.status == 'success') {
						let itemTotalQty = response.data.length;
						this.commonService.setCartItmsCount(itemTotalQty);
						} 
					})
					/************/
				},1500)

			}
			if (response.status=='error') {
			  this.toastr.error( response.message,'Error:');
			}
		  }, (error) => {
			// console.log(error);
		  });
		}
		// console.log(this.signUpForm.value);
	}


}
